import { render, staticRenderFns } from "./CreatePrice.vue?vue&type=template&id=34d835cf&"
import script from "./CreatePrice.vue?vue&type=script&lang=js&"
export * from "./CreatePrice.vue?vue&type=script&lang=js&"
import style0 from "./CreatePrice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports